export enum ComplianceResult {
  Pending = 1,
  Pass = 2,
  Fail = 3
}

export const ComplianceResultLabels: Record<ComplianceResult, string> = {
  [ComplianceResult.Pending]: 'Pending',
  [ComplianceResult.Pass]: 'Pass',
  [ComplianceResult.Fail]: 'Fail'
};

export const ComplianceResultLabelKeys: Record<ComplianceResult, string> = {
  [ComplianceResult.Pending]: 'compliance.shared.results.pending',
  [ComplianceResult.Pass]: 'compliance.shared.results.pass',
  [ComplianceResult.Fail]: 'compliance.shared.results.fail'
};

export const ResultComplianceLabels: Record<ComplianceResult, string> = {
  [ComplianceResult.Pass]: 'Compliant',
  [ComplianceResult.Fail]: 'Non-Compliant',
  [ComplianceResult.Pending]: ''
};